import * as React from 'react';
import ImageSource from '@th/shared/src/types/ImageSource';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import { useEffect, useRef } from 'react';
import SvgIcon from '../../icons/SvgIcon';

type Props = {
  imageUrls: Array<ImageSource>;
  currentIndex: number;
  numImages: number;
  showPreviousImage: () => void;
  showNextImage: () => void;
  updateCurrentIndex: (index: number) => void;
};

export default function ListingImagesSingleImageFullScreenModalCarousel({
  imageUrls,
  currentIndex,
  numImages,
  showPreviousImage,
  showNextImage,
  updateCurrentIndex,
}: Props) {
  const { isMobile, isDesktop } = useWindowDimensions();
  const carouselRef = useRef<Carousel>();
  useEffect(() => {
    carouselRef.current?.forceFocus();
  }, []);

  return (
    <div className="flex flex-1 flex-row items-center">
      {isDesktop && (
        <button
          className="flex p-8 text-white hover:text-primary"
          onClick={showPreviousImage}
        >
          <SvgIcon name={'HiChevronLeft'} className="-ml-1 h-10 w-10 " />
        </button>
      )}
      <div className="flex flex-1 h-full">
        <Carousel
          ref={carouselRef}
          axis={'horizontal'}
          showArrows={false}
          swipeable={isMobile}
          showStatus={false}
          showIndicators={false}
          infiniteLoop
          showThumbs={false}
          useKeyboardArrows
          dynamicHeight={false}
          emulateTouch
          thumbWidth={100}
          selectedItem={currentIndex}
          transitionTime={100}
          swipeScrollTolerance={5}
          onChange={updateCurrentIndex}
        >
          {imageUrls.map(i => (
            <img
              src={i.uri}
              alt={`Image ${currentIndex + 1} of ${numImages}`}
              className="object-contain"
              style={{ height: 0, minHeight: '100%' }} // this sets the image to match the parent flexbox. it was also necessary to add { height: 100% } to dom elements of Carousel. This is done in globals.css
              key={i.uri}
            />
          ))}
        </Carousel>
      </div>
      {isDesktop && (
        <button
          className="flex p-8 text-white hover:text-primary"
          onClick={showNextImage}
        >
          <SvgIcon name={'HiChevronRight'} className="-ml-1 h-10 w-10 " />
        </button>
      )}
    </div>
  );
}
